"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 11 11';

var CaretLeft = function CaretLeft() {
  return _react["default"].createElement("path", {
    transform: "rotate(90) translate(-6.5, -17)",
    d: "M7 10l5 5 5-5z"
  });
};

var _default = (0, _createSvgIcon["default"])(CaretLeft, {
  viewBox: viewBox
});

exports["default"] = _default;